import request from "@/http/request"
import {
    score,
    getResultList,
    certificatePrint,
    downloadScoreReview,
    uploadScoreReview,
    getScoreReview
} from '@/http/api'

export const getScoreList = (data) => {
    return request({
        url: score,
        data
    })
}

export const exportScoreList = (data) => {
    return request({
        url: getResultList,
        data
    })
}

export const exportCertificate = (data) => {
    return request({
        url: certificatePrint,
        data
    })
}
export const downRepresen = (data) => {//学生，下载申诉表模板
    return request({
        url: downloadScoreReview,
        data
    })
}
export const ScoreReview = (data) => {//，自行上传申诉表
    return request({
        url: uploadScoreReview,
        isUpload: true,
        data
    })
}
export const usergetScoreReview = (data) => {
    return request({
        url: getScoreReview,
        data
    })
}